/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'typeface-roboto';
import 'typeface-roboto-slab';

// Contexts.
import { AnalyticsProvider } from './src/contexts/AnalyticsContext/';
import { UserSessionProvider } from './src/contexts/UserSessionContext';

export const wrapPageElement = ({ element }) => <>{element}</>;

export const wrapRootElement = ({ element }) => {
	if (window.location.href.match(/http(s?):\/\/(seq.docker.localhost|sequencing.com)\/tests\/web-performance\/011/)) {
		return <>{element}</>;
	}

	return (
		<UserSessionProvider>
			<AnalyticsProvider>{element}</AnalyticsProvider>
		</UserSessionProvider>
	);
};
